// @ts-ignore
import * as L from 'leaflet/dist/leaflet-src.esm.js';
export class ZoomControl {
    constructor() {
        this.object = null;
        this.object = null;
    }
    /**
     * This function creates a zoom control and returns it.
     * @param {string} [position=topright] - string = 'topright'
     * @returns The zoomControl object.
     */
    createZoomControl(position = 'topright') {
        const zoomControl = L.control.zoom({ position });
        this.object = zoomControl;
        return zoomControl;
    }
    /**
     * If the object exists, remove it.
     * @returns The object is being returned.
     */
    removeZoomControl() {
        if (!this.object)
            return;
        this.object.remove();
        this.object = null;
    }
    /**
     * Create an object with a minZoom and maxZoom property, and set the values to the min and max
     * parameters.
     * @param {number} min - The minimum zoom level.
     * @param {number} max - number - The maximum zoom level.
     * @returns An object with two properties, minZoom and maxZoom.
     */
    static createMinMaxLevelOptions(min, max) {
        return { minZoom: min, maxZoom: max };
    }
}
//# sourceMappingURL=zoomControl.js.map